import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { cn } from '@/lib/utils';

import RuleBuilderAggregateAttribute from './RuleBuilderAggregateAttribute';
import RuleBuilderRemoveButton from './RuleBuilderRemoveButton';
import RuleBuilderText from './RuleBuilderText';
import type {
  AggregatePath,
  AndConditionPath,
  RuleBuilderObjectType,
  RuleEntityType,
} from './types';
import { useAudienceRuleForm } from './types';

type Props = {
  basePath: AndConditionPath;
  ruleEntity: RuleEntityType;
  object: RuleBuilderObjectType;
  disabled?: boolean;
  onConditionRemove: () => void;
};

const buildAggregatePath = (basePath: AndConditionPath): AggregatePath => `${basePath}.aggregate`;

const RuleBuilderMultiConditionHeader = ({
  basePath,
  ruleEntity,
  disabled = false,
  onConditionRemove,
}: Props) => {
  const form = useAudienceRuleForm();

  return (
    <div className="flex w-full flex-1 items-start justify-start gap-6">
      <div
        className={cn(
          'flex items-start justify-start gap-6',
          'max-xl:row-gap-2 max-xl:gap-4.5',
          'max-lg:row-gap-1.5 max-lg:gap-3',
          'max-sm:flex-1 max-sm:flex-col',
        )}
      >
        <div className="flex items-center gap-2">
          {ruleEntity.icon}
          <RuleBuilderText variant="body1">{ruleEntity.name}</RuleBuilderText>
        </div>
        {ruleEntity.cardinality === 'many' && !ruleEntity.hideAggregate && (
          <RuleBuilderAggregateAttribute
            form={form}
            fields={buildAggregatePath(basePath)}
            className="max-[650px]:pl-[52px]"
            disabled={disabled}
          />
        )}
      </div>
      <RuleBuilderRemoveButton
        title={<Trans>Remove rule</Trans>}
        aria-label={t`Remove rule`}
        disabled={disabled}
        onClick={onConditionRemove}
      />
    </div>
  );
};

export default RuleBuilderMultiConditionHeader;
